// src/data/zoneCenters.js
// Geographic center coordinates for each zone.
// Used to pre-cache map tiles when a user selects their zone.
export const ZONE_CENTERS = {
  'N.O. East': { lat: 30.019, lon: -89.958 },
  'Lakeview': { lat: 29.998, lon: -90.114 },
  'Gentilly': { lat: 30.007, lon: -90.047 },
  'Lower 9th Ward': { lat: 29.97, lon: -89.996 },
  'Carrollton': { lat: 29.944, lon: -90.135 },
  'Uptown': { lat: 29.928, lon: -90.096 },
  'Mid-City': { lat: 29.983, lon: -90.087 },
  'French Quarter': { lat: 29.958, lon: -90.064 },
  'Algiers': { lat: 29.928, lon: -90.035 },
  'Northshore / Slidell': { lat: 30.286, lon: -89.781 },
  'Jefferson Parish':   { lat: 29.917, lon: -90.054 },
  'Metairie':           { lat: 29.991, lon: -90.188 },
  'Kenner':             { lat: 29.994, lon: -90.244 },
  'St. Bernard Parish': { lat: 29.937, lon: -89.974 },
  'St. Tammany Parish': { lat: 30.476, lon: -90.101 },
  'Plaquemines Parish': { lat: 29.845, lon: -89.988 },
  'St. Charles Parish': { lat: 29.898, lon: -90.380 },
  'St. John Parish':    { lat: 30.071, lon: -90.482 },
  'Treme':              { lat: 29.967, lon: -90.071 },
  'Gretna':             { lat: 29.914, lon: -90.054 },
  'Harvey':             { lat: 29.903, lon: -90.077 },
  'Marrero':            { lat: 29.899, lon: -90.101 },
  'Westwego':           { lat: 29.903, lon: -90.144 },
  'Harahan':            { lat: 29.936, lon: -90.207 },
  'Elmwood':            { lat: 29.952, lon: -90.218 },
  'Arabi':              { lat: 29.959, lon: -89.993 },
  'Chalmette':          { lat: 29.943, lon: -89.965 },
  'Meraux':             { lat: 29.920, lon: -89.926 },
  'Violet':             { lat: 29.893, lon: -89.893 },
  'Covington':          { lat: 30.476, lon: -90.101 },
  'Mandeville':         { lat: 30.368, lon: -90.064 },
  'Madisonville':       { lat: 30.405, lon: -90.170 },
  'Pearl River':        { lat: 30.369, lon: -89.754 },
  'Belle Chasse':       { lat: 29.851, lon: -89.989 },
  'Braithwaite':        { lat: 29.845, lon: -89.944 },
  'Empire':             { lat: 29.413, lon: -89.605 },
  'Port Sulphur':       { lat: 29.487, lon: -89.694 },
  'Boutte':             { lat: 29.893, lon: -90.387 },
  'Destrehan':          { lat: 29.944, lon: -90.353 },
  'Luling':             { lat: 29.913, lon: -90.364 },
  'Norco':              { lat: 29.989, lon: -90.406 },
  'LaPlace':            { lat: 30.068, lon: -90.471 },
  'Reserve':            { lat: 30.061, lon: -90.553 },
  'Thibodaux':          { lat: 29.796, lon: -90.820 },
  'Lockport':           { lat: 29.649, lon: -90.541 },
  'Golden Meadow':      { lat: 29.378, lon: -90.268 },
  'Cut Off':            { lat: 29.528, lon: -90.344 },
  'Houma':              { lat: 29.596, lon: -90.719 },
  'Morgan City':        { lat: 29.699, lon: -91.207 },
  'Hammond':            { lat: 30.504, lon: -90.462 },
  'Ponchatoula':        { lat: 30.438, lon: -90.441 },
  'Denham Springs':     { lat: 30.486, lon: -90.957 },
  'Walker':             { lat: 30.487, lon: -90.864 },
  'Gonzales':           { lat: 30.222, lon: -90.921 },
  'Prairieville':       { lat: 30.300, lon: -90.981 },
  'Baton Rouge':        { lat: 30.458, lon: -91.140 },
  // ── St. Charles Parish (additions) ──────────────────────────────
  'St. Rose':           { lat: 29.960, lon: -90.310 },
  'Hahnville':          { lat: 29.972, lon: -90.412 },
  'Ama':                { lat: 29.951, lon: -90.330 },
  'New Sarpy':          { lat: 29.971, lon: -90.376 },

  // ── St. John Parish (additions) ──────────────────────────────────
  'Edgard':             { lat: 30.004, lon: -90.560 },
  'Lutcher':            { lat: 30.048, lon: -90.700 },

  // ── Plaquemines Parish (additions) ───────────────────────────────
  'Buras':              { lat: 29.354, lon: -89.519 },
  'Myrtle Grove':       { lat: 29.575, lon: -89.837 },
  'Venice':             { lat: 29.274, lon: -89.354 },

  // ── Terrebonne Parish (additions) ────────────────────────────────
  'Schriever':          { lat: 29.723, lon: -90.823 },
  'Gray':               { lat: 29.668, lon: -90.787 },
  'Thibodaux':          { lat: 29.796, lon: -90.820 },

  // ── Tangipahoa Parish (additions) ────────────────────────────────
  'Amite':              { lat: 30.731, lon: -90.508 },
  'Kentwood':           { lat: 30.934, lon: -90.508 },
  'Independence':       { lat: 30.634, lon: -90.504 },

  // ── Livingston Parish (additions) ────────────────────────────────
  'Livingston':         { lat: 30.495, lon: -90.753 },
  'Albany':             { lat: 30.499, lon: -90.574 },
  'Springfield':        { lat: 30.408, lon: -90.530 },

  // ── Ascension Parish (additions) ─────────────────────────────────
  'Sorrento':           { lat: 30.185, lon: -90.866 },
  'Donaldsonville':     { lat: 30.101, lon: -90.995 },
  'Dutchtown':          { lat: 30.091, lon: -90.900 },

  // ── East Baton Rouge (additions) ─────────────────────────────────
  'Zachary':            { lat: 30.650, lon: -91.152 },
  'Central':            { lat: 30.557, lon: -91.034 },
  'Baker':              { lat: 30.587, lon: -91.168 },

  // ── St. Mary Parish ──────────────────────────────────────────────
  'Patterson':          { lat: 29.694, lon: -91.302 },
  'Berwick':            { lat: 29.693, lon: -91.219 },
  'Franklin':           { lat: 29.797, lon: -91.501 },

  // ── Iberia Parish ────────────────────────────────────────────────
  'New Iberia':         { lat: 30.003, lon: -91.818 },
  'Jeanerette':         { lat: 29.912, lon: -91.662 },
  'Delcambre':          { lat: 29.951, lon: -91.990 },

  // ── Lafayette Parish ─────────────────────────────────────────────
  'Lafayette':          { lat: 30.224, lon: -92.020 },
  'Youngsville':        { lat: 30.098, lon: -91.994 },
  'Broussard':          { lat: 30.145, lon: -91.961 },
  'Carencro':           { lat: 30.318, lon: -92.049 },

  // ── Calcasieu Parish ─────────────────────────────────────────────
  'Lake Charles':       { lat: 30.226, lon: -93.218 },
  'Sulphur':            { lat: 30.237, lon: -93.376 },
  'Westlake':           { lat: 30.244, lon: -93.263 },
  'Iowa':               { lat: 30.229, lon: -93.018 },

  // ── St. Landry Parish ────────────────────────────────────────────
  'Opelousas':          { lat: 30.534, lon: -92.081 },
  'Eunice':             { lat: 30.497, lon: -92.417 },
  'Sunset':             { lat: 30.412, lon: -92.062 },
  'Washington':         { lat: 30.615, lon: -92.054 },

  // ── Rapides Parish ───────────────────────────────────────────────
  'Alexandria':         { lat: 31.311, lon: -92.445 },
  'Pineville':          { lat: 31.322, lon: -92.434 },
  'Ball':               { lat: 31.416, lon: -92.407 },
  'Boyce':              { lat: 31.390, lon: -92.666 },

  // ── Bossier / Caddo ──────────────────────────────────────────────
  'Shreveport':         { lat: 32.525, lon: -93.750 },
  'Bossier City':       { lat: 32.516, lon: -93.732 },
  'Benton':             { lat: 32.694, lon: -93.737 },
  'Haughton':           { lat: 32.531, lon: -93.502 },

  // ── Jefferson Parish (additions) ─────────────────────────────────
  'Waggaman':           { lat: 29.922, lon: -90.213 },
  'River Ridge':        { lat: 29.961, lon: -90.225 },
  'Avondale':           { lat: 29.921, lon: -90.196 },
  'Grand Isle':         { lat: 29.233, lon: -89.958 },
  'Lafitte':            { lat: 29.661, lon: -90.115 },
  'Jean Lafitte':       { lat: 29.735, lon: -90.105 },

  // ── St. Tammany additions ────────────────────────────────────────
  'Abita Springs':      { lat: 30.487, lon: -89.967 },
  'Lacombe':            { lat: 30.313, lon: -89.932 },
  'Folsom':             { lat: 30.634, lon: -90.189 },
  'Slidell':            { lat: 30.275, lon: -89.781 },

};
